import { useEffect, useRef } from 'react';
import { useAtomValue } from 'jotai';

import { editingQuizIdAtom } from '../focus/editModeAtom';

export const useQuizSliderFocusScrollRef = (id: string) => {
  const ref = useRef<HTMLDivElement>(null);

  const editingId = useAtomValue(editingQuizIdAtom);

  useEffect(() => {
    if (editingId === id) {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [editingId, id]);

  return ref;
};
